import type { ConnectedTypes } from '../../../make-connected';
import type { Types } from '../../../types';

export function parseDayIndices (
  days:    ConnectedTypes.event['days'] | ConnectedTypes.course['days'],
  settings: ConnectedTypes.divisionSettings
): Types.Shared.DayIndices | undefined {
  if (!days) return;

  if (days.length) return days.map(x => x.day);

  // empty days means all days selected (since no days selected is prohibited)
  return [...Array.from({ length: settings.numDays })].map((_, i) => i);
}